import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MainVideoPlayer } from './MainVideoPlayer';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from "../contexts/LocalizationContext/languages/LanguageContext";
import { Button, Grid, styled, Typography } from "@mui/material";
import { LayoutContext } from "../contexts/LayoutContext/LayoutContext";
import { BackgroundVideo } from "./BackgroundVideo";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import shelterCover from '../media/pictures/cits-shelter-cover.jpg';
import { Box } from "@mui/system";
import { socialMediaIcons } from "../displayConfig";
import { SpotifyIcon } from "../media/platform-icons/music-platforms/SpotifyIcon";
import paypalIcon from '../media/paypal_icon.png'
import {
    followOnFacebookCits,
    followOnInstagramCits,
    followOnTikTokCits,
    followOnTwitterCits,
    followOnYouTubeCits,
    PagesList,
    paypalDonateLink,
    spotifyCits,
} from "../config";
import { OgMetaTagsPages } from "./ReusableComponents/OgMetaTags";
import { CountdownToEvent } from "./CountdownToEvent/CountdownToEvent";
import PhotoGalleryBackground from "../media/pictures/gigs/PhotoGalleryBackground.jpg";
import { GigEvent } from "./GigEvent/GigEvent";
import { SocialMediaIconsRow } from "./ReusableComponents/SocialMediaIconsRow";

const MyButton = styled(Button)(({ theme }) => ({
    width: '25%',
    border: '2px solid white',
    borderColor: '#fff',
    [theme.breakpoints.up("md")]: {
        fontSize: 20
    },
    [theme.breakpoints.down("md")]: {
        width: '45%',
        opacity: 0.6,
    },
    [theme.breakpoints.down("sm")]: {
        width: '48%',
        opacity: 0.6,
        fontSize: 13,
    },
}));

const BandcampPlayer = ({ isMobile, trackId }) => {
    const isReactSnap =
        typeof navigator !== "undefined" &&
        navigator.userAgent.includes("ReactSnap");

    if (isReactSnap) {
        return null;
    }

    return (
        <iframe
            style={{
                border: 0,
                width: isMobile ? "100vw" : "700px",
                height: isMobile ? "442px" : "884px",
            }}
            src={`https://bandcamp.com/EmbeddedPlayer/track=${trackId}/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/`}
            seamless
            title="Bandcamp Player"
        >
            <a href={`https://campingintheskies.bandcamp.com/track/${trackId}`}>
                Stuck In A Dream by Camping in the skies
            </a>
        </iframe>
    );
};

export const Homepage = ({ pageMeta }) => {
    const { theme } = useContext(ThemeContext);
    const { isMobile } = useContext(LayoutContext);
    const { dictionary } = useContext(LanguageContext);
    const location = useLocation();
    const navigate = useNavigate();
    const observerRef = useRef();

    // Define the target date and time
    const targetDate = new Date('2025-03-13T20:00:00+00:00'); // London time (UTC+0)

    // Get the current date and time
    const [currentDate, setCurrentDate] = useState(new Date());

    // Update the current date and time every second
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDate(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // Check if the current date is before or after the target date
    const isBeforeTargetDate = currentDate < targetDate;

    useEffect(() => {
        const elementId = location.hash.substring(1); // Remove the leading '#' from the hash
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };

        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    navigate(`#${entry.target.id}`, { replace: true });
                }
            });
        };

        observerRef.current = new IntersectionObserver(callback, options);

        const targets = document.querySelectorAll(
            '#album, #stories, #bandcamp-album-everything-starts, #watch-and-feel',
        );
        targets.forEach((target) => observerRef.current.observe(target));

        return () => {
            observerRef.current.disconnect();
        };
    }, [navigate]);

    return (
        <Box>
            <OgMetaTagsPages content={pageMeta} />
            {/*<Grid*/}
            {/*    container*/}
            {/*    direction="column"*/}
            {/*    justify="center"*/}
            {/*    alignItems="center"*/}
            {/*    style={{ height: '100%' }}*/}
            {/*>*/}
            {/*    /!* Conditionally render BandcampPlayer *!/*/}
            {/*    {!isBeforeTargetDate && (*/}
            {/*        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 6, width: "100%", height:"100%" }}>*/}
            {/*            <BandcampPlayer isMobile={isMobile} trackId="2446586234" />*/}
            {/*        </Box>*/}
            {/*    )}*/}
            {/*</Grid>*/}
                {/* <GigEvent /> */}

            {/* Hero Section - Background Image */}
            <Box
                height={isMobile ? "50vh" : "100vh"}
                width="100vw"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                    backgroundImage: `url(${shelterCover})`,
                    backgroundSize: isMobile ? 'cover' : 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
            >
                {/* Reusable Social Media Icons Row */}
                <SocialMediaIconsRow />
            </Box>

            {/* About Section */}
            <Box sx={{ width: '100%', height: '35vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography textAlign="center" variant="h5">
                    Alt rock band where land is no limit. currently recording their next release
                    <Link to={PagesList.aboutUs.route}> read more...</Link>
                </Typography>
            </Box>
        </Box>
    );
};